import _ from "lodash"
import Client from "data/_client"
import notificationService from "data/notification"
import fieldCopyDependencyMap from "data/field-copy-dependency-map"

import { lookup, resourceFrom } from 'data/lib/lookup-field'

// Private --------------------------------------------------
const copy_cache = {
  path: null,
  field: null,
  id: null,
  value: null,
  _meta: {section: null, field: null}
}

function setCache(path, field, id, value) {
  copy_cache.path = path
  copy_cache.field = field
  copy_cache.id = id
  copy_cache.value = value
  copy_cache._meta = lookup(resourceFrom(path), field)
}

function findDataAttributes(target) {
  if(!target) return {field: null, id: null}

  // first check target
  if(_.get(target, 'dataset.field')) {
    return {
      field: _.get(target, 'dataset.field'),
      id: parseInt(_.get(target, 'dataset.id'))
    }
  } else {
    // then check parents
    const p = target.closest('[data-field]')
    if(p) {
      return {
        field: _.get(p, 'dataset.field'),
        id: parseInt(_.get(p, 'dataset.id'))
      }
    } else {
      // otherwise check children
      const c = target.querySelector('[data-field]')
      if(c) {
        return {
          field: _.get(c, 'dataset.field'),
          id: parseInt(_.get(c, 'dataset.id'))
        }
      }
    }
  }
}

function specialCase(field, path, row) {
  switch(true) {
    case (_.includes(path, 'asset-management/chart') && field === 'isdefault'):
      notificationService.notify({
        type: "warn",
        message: "Default chart must be set manually",
        dismiss: 3000
      })
      return true
    case (_.includes(path, 'asset-management/portfolios') && field === 'useraccess'):
      notificationService.notify({
        type: "warn",
        message: "User accesss must be set manually",
        dismiss: 3000
      })
      return true
    case (_.includes(path, '/multifamily/rent-roll')) && _.includes(['unitinventorydetail.area', 'unitinventorydetail.unitsOccupied', 'unitinventorydetail.unitsTotal', 'unitinventorydetail.unitsVacant'], field):
      notificationService.notify({
        type: "info",
        message: "Grouped fields also copied",
        dismiss: 3000
      })
      return false
    default:
      return false
  }
}

// Public --------------------------------------------------
export function copy(target, row) {
  const attributes = findDataAttributes(target)
  const field = _.get(attributes, "field")
  const id = _.get(attributes, "id")
  const path = window.location.pathname
  if(specialCase(field, path, row)) {
    setCache(null, null, null, null)
  } else {
    setCache(path, field, id, row[field])
  }
}

export async function paste(target, row, updateFn, table, selectedRows:object[]=[]) {
  if(_.isEmpty(selectedRows) && row.systeminput === "systemImmutable") return;
  const attributes = findDataAttributes(target)
  let field = _.get(attributes, "field")
  const id = _.get(attributes, "id")
  const propertyid = _.get(row, "propertyid")
  if(field && field === copy_cache.field && window.location.pathname === copy_cache.path) {
    if(_.includes(field, ".")) field = _.first(_.split(field, "."))
    let orig = await Client.get(`${table}?${table}id=eq.${copy_cache.id}`)
    if(_.isArray(orig)) orig = _.find(orig, {[table+'id']: copy_cache.id}) || _.first(orig)
    const deps = fieldCopyDependencyMap[field] || []
    if(orig) {
      const payload = {}
      payload[field] = orig[field]
      payload[`${table}id`] = id
      _.each(deps, (d) => {
        payload[d] = orig[d]
      })
      if (selectedRows.length) {
        delete payload[`${table}id`]
        await Client.patch(`${table}?${table}id=in.${_.map(selectedRows, `${table}id`)}`, payload)
      } else {
        await Client.patch(`${table}?${table}id=eq.${id}`, payload)
      }
      updateFn(propertyid)
    }
  } else {
    notificationService.notify({
      type: "warn",
      message: "You can only paste values copied from the same column",
      dismiss: 3000
    })
  }
}

export function canPaste(target, selected?) {
  if (selected) {
    return !_.some(selected, (s) => _.get(s, 'systeminput') === "systemImmutable")
  }
  const attributes = findDataAttributes(target)
  const field = _.get(attributes, "field")
  if(field && field === copy_cache.field && window.location.pathname === copy_cache.path) {
    return true
  } else return false
}

export function getPasteInfo() {
  return {...copy_cache}
}